import { redirect } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import { DiscountCodeCreateData } from "@/routes/lecturer/routes/discountCode/create/types/discountCodeCreateData.ts";
import { DiscountTypeEnum } from "@/routes/lecturer/routes/discountCode/main/types/discountTypeEnum.ts";
import { ParseHelper } from "@/services/helpers/parseHelper.ts";

const parseDiscountType = (value: string | number): DiscountTypeEnum => {
  const numValue =
    typeof value === "string" ? Number.parseInt(value, 10) : value;

  if (isNaN(numValue) || !Object.values(DiscountTypeEnum).includes(numValue)) {
    return DiscountTypeEnum.Percentage; // Default fallback
  }

  return numValue as DiscountTypeEnum;
};

export const discountCodeCreateAction = async ({
  request,
}: {
  request: Request;
}) => {
  try {
    const formData = await request.formData();
    const rawData = Object.fromEntries(
      formData,
    ) as unknown as DiscountCodeCreateData;
    // Parse and validate form data
    const code = rawData.code?.trim().toUpperCase() || "";
    const type = parseDiscountType(rawData.type);
    const discountValue = ParseHelper.parseNumber(rawData.discountValue);

    // Process the data
    const processedData: DiscountCodeCreateData = {
      courseId: rawData.courseId,
      code,
      type,
      discountValue: type === DiscountTypeEnum.Free ? 0 : discountValue,
      isBasketDiscount: ParseHelper.parseBoolean(rawData.isBasketDiscount),
      applyOnDiscountedPrice: ParseHelper.parseBoolean(
        rawData.applyOnDiscountedPrice,
      ),
      isReusable: ParseHelper.parseBoolean(rawData.isReusable),
      startDate: rawData.startDate,
      endDate: rawData.endDate,
    };

    // Get return URL
    const url = new URL(request.url);
    const returnUrl =
      url.searchParams.get("returnUrl") || "/lecturer/discount-codes";

    // Make API call
    const result = await apiEndpoints.createLecturerDiscountCode(processedData);

    if (result.success) {
      return redirect(returnUrl);
    } else {
      return {
        success: false,
        error: result.message || "İndirim kodu oluşturulurken bir hata oluştu",
      };
    }
  } catch (err) {
    throw err;
  }
};
